import React, { useEffect, useState } from "react";
import ReactExport from "react-data-export";
import { format } from "date-fns";
import { Button } from "../layer/wrapper";
import { getObjectPLO } from "../layer/reportBotPLO";
import { calReportAging } from "utils/calReportAging";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function ExportPLO({ loan = [], buroDate = new Date() }) {
  const [loading, setLoading] = useState(false);
  const [plo, setPlo] = useState([]);
  const [countExport, setCountExport] = useState(0);

  useEffect(() => {
    if (plo.length > 0) {
      const getExportId = document.getElementById("export-excel-plo");
      getExportId.click();
    }
  }, [plo]);

  const onClickAging = async () => {
    try {
      setLoading(true);

      const { dataPrinciple: newLoans } = calReportAging(
        loan,
        new Date(buroDate)
      );

      let keep = [];
      let index = 0;
      for (const itemLoan of newLoans) {
        if (index >= newLoans.length) {
          break;
        }
        const valuePlo = getObjectPLO(itemLoan, buroDate, true);
        keep.push(valuePlo);
        index++;
      }
      setPlo(keep);
      setCountExport(keep.length);
    } catch (error) {
      console.log("loading error", error);
    } finally {
      setLoading(false);
    }
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    let style = { font: { sz: 14 }, alignment: "right", fill: filled_col_0 };

    for (let i = 0; i < data.length; i++) {
      var filled = { fgColor: { rgb: "FFFFFF" } };
      var filled_col_0 = { patternType: "solid", fgColor: { rgb: "FDFFA7" } };
      result.push([
        {
          value: `${data[i]["รหัสสถาบัน"] || ""}`,
          style,
        },
        {
          value: `${data[i]["งวดข้อมูล"] || ""}`,
          style,
        },
        {
          value: `${data[i]["เลขที่สัญญา"] || ""}`,
          style,
        },
        {
          value: `${data[i]["รหัสของผู้กู้"] || ""}`,
          style,
        },
        {
          value: `${data[i]["ประเภทรหัสของผู้กู้"] || ""}`,
          style,
        },
        {
          value: `${data[i]["ชื่อผู้กู้"] || ""}`,
          style,
        },
        {
          value: `${data[i]["ประเภทสินเชื่อ"] || ""}`,
          style,
        },
        {
          value: `${data[i]["ยอดคงค้าง"] || ""}`,
          style,
        },
        {
          value: `${data[i]["อัตราดอกเบี้ยที่ผิดนัดชำระหนี้"] || ""}`,
          style,
        },
        {
          value: `${data[i]["จำนวนวันที่ค้างชำระ"] || ""}`,
          style,
        },
        {
          value: `${data[i]["การตัดหนี้สูญ"] || ""}`,
          style,
        },
      ]);
    }
    return result;
  };

  let sameObjSet = {
    width: { wch: 20 },
    style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "รหัสสถาบัน",
          ...sameObjSet,
        },
        {
          title: "งวดข้อมูล",
          ...sameObjSet,
        },
        {
          title: "เลขที่สัญญา",
          ...sameObjSet,
        },
        {
          title: `รหัสของผู้กู้`,
          ...sameObjSet,
        },
        {
          title: `ประเภทรหัสของผู้กู้`,
          ...sameObjSet,
        },
        {
          title: `ชื่อผู้กู้`,
          ...sameObjSet,
        },
        {
          title: `ประเภทสินเชื่อ`,
          ...sameObjSet,
        },
        {
          title: `ยอดคงค้าง`,
          ...sameObjSet,
        },
        {
          title: `อัตราดอกเบี้ยที่ผิดนัดชำระหนี้`,
          ...sameObjSet,
        },
        {
          title: `จำนวนวันที่ค้างชำระ`,
          ...sameObjSet,
        },
        {
          title: `การตัดหนี้สูญ`,
          ...sameObjSet,
        },
      ],
      data: createDataWithStyle(plo),
    },
  ];

  return (
    <div>
      <ExcelFile
        filename={`EXPORT_PLO_${format(new Date(buroDate), "yyyy-MM-dd")}`}
        element={<button id="export-excel-plo" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSet} name="PLO"></ExcelSheet>
      </ExcelFile>
      <Button disabled={loading || !loan.length} onClick={onClickAging}>
        {countExport > 0 && countExport} Export PLO
      </Button>
    </div>
  );
}

export default ExportPLO;
